import React from 'react'
import { com } from '@eidu/web'
import { Select, TextInput } from '@common/ui'
import { CustomSemanticLinkKey, exampleKeys } from './useCustomSemanticLinkKey'
import FieldType = com.eidu.entity.field.FieldType

const fieldTypeOptions: FieldType[] = [FieldType.Reference, FieldType.Text, FieldType.Number, FieldType.Date]

type CustomSemanticLinkKeyFieldsProps = {
  customKey: CustomSemanticLinkKey
  fieldType: FieldType
  onFieldTypeChange: (fieldType: FieldType) => void
}

const CustomSemanticLinkKeyFields = ({ customKey, fieldType, onFieldTypeChange }: CustomSemanticLinkKeyFieldsProps) => (
  <>
    <TextInput
      label="Custom key"
      placeholder={`e.g. ${exampleKeys}`}
      value={customKey.input}
      error={customKey.error}
      onChange={(e) => customKey.change(e.target.value)}
      onBlur={customKey.validate}
    />
    <Select
      label="Field type"
      value={fieldType.toString()}
      onChange={(value) => {
        const selected = fieldTypeOptions.find((ft) => ft.toString() === value)
        if (selected) onFieldTypeChange(selected)
      }}
      data={fieldTypeOptions.map((ft) => ({
        value: ft.toString(),
        label: ft === FieldType.Reference ? 'Reference / Reference Set' : ft.toString(),
      }))}
    />
  </>
)

export default CustomSemanticLinkKeyFields
